import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import { FormBuilder, Validators,FormArray,FormControl } from '@angular/forms';


import {Title} from '@angular/platform-browser';
import {ListingService } from '../listing.service';

@Component({
  selector: 'app-approve-refund',
  templateUrl: './approve-refund.component.html',
  styleUrls: ['./approve-refund.component.css','../../app.component.css','../admin.css'],
    providers:[ListingService]
})
export class ApproveRefundComponent implements OnInit {

  eventId: any;
  detailArray :any;
  errorMessage : any;
  spinner: boolean = false;
    rList: any;
    htmlVariable:any;
    refund:any;

  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<ApproveRefundComponent>, private formBuilder: FormBuilder, private ListingService: ListingService,private snackBar: MdSnackBar) {
      this.refund = this.formBuilder.group({
          'message': ['', Validators.required],
          'eventId':'',
           myChoices: new FormArray([])
      });
  }

  ngOnInit() {
    if(this.eventId){
      this.getRefundList(this.eventId)
      this.refund.controls['eventId'].patchValue(this.eventId);
    }else{
      this.snackBar.open('something went wrong','',{duration:4000});
      setTimeout(()=>{ this.dialogRef.close(); }, 2000);
    }
  }

  getRefundList(eventId){
      this.spinner = true;
      this.ListingService.getRefundList({eventId:eventId}).subscribe(
              response => {
            this.spinner = false;
            this.detailArray = response;
            this.rList=response.refundList;
          },
              error => {
                this.spinner = false;
                this.errorMessage = <any>error;
                this.snackBar.open('something went wrong','',{duration:4000});
          }
      );
    }
    toggleSelect = function(event){
        this.allneighbourhoods = event.target.checked;
        this.rList.forEach(function(item){
            item.selected = event.target.checked;
        });
    }

    close() {
        this.dialogRef.close();
    }

    refundCheck() {

        const refundArray = <FormArray>this.refund.controls.myChoices;
        var datas  = this.rList.filter(function (data) { return data.selected == true });
        for (var i = 0; i < datas.length; i++) {
            refundArray.push(new FormControl(datas[i].refundId));
        }
        if (this.refund.dirty) {

            if (this.refund.valid &&  this.FormValid(this.refund.controls.myChoices.length)) {
                this.spinner = true;
                this.ListingService.approveRefund(this.refund.value)
                    .subscribe(
                        response => {
                        this.spinner = false;
                        this.snackBar.open(response.message, '', <MdSnackBarConfig>{duration: 4000});
                        this.dialogRef.close(response.status);
                    },
                        error => {
                        this.spinner = false;
                        this.errorMessage = <any>error;
                        this.spinner = false;
                    }
                );
            }
        } else {
            // this.dialogRef.close();
        }
    }

    FormValid(Id) {
        var flag = true;
        if (Id > 0) {
            flag = true;
            this.htmlVariable = '';
        } else {

            flag = false;
            this.htmlVariable = '*Select atleast one entry for approval';
        }
        return flag;
    }

    }



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/approve-refund/approve-refund.component.ts